export default __webpack_public_path__ + "static/the-procurement-management-strategic-playbook-833bf551fc5d3b02447ba950f411ad98.pdf";